import { render, staticRenderFns } from "./ManpowerModal.vue?vue&type=template&id=ca27249c&"
import script from "./ManpowerModal.vue?vue&type=script&lang=js&"
export * from "./ManpowerModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports